import { UpdateTodoEvent } from './update-todo.event';
import { TodoContext } from '../context';

export async function updateTodo(evt: UpdateTodoEvent, ctx: TodoContext) {
  await ctx.state('todos').patch({
    id: evt.id,
    title: evt.title,
  });
}
